import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import { getAllAnswers } from '../../../utils/onboardingStorage'

export default function ObstaclesFeedbackPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  // Get the past experience answer
  const allAnswers = getAllAnswers()
  const pastExperience =
    allAnswers.pastExperience?.answer_key || 'No, first time'
  const gaveUp = pastExperience === 'Yes, but gave up'

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <FeedbackPage
      emoji="💪"
      heading={t(
        gaveUp
          ? 'pages.onboarding.v1.obstaclesFeedback.gaveUp.heading'
          : 'pages.onboarding.v1.obstaclesFeedback.general.heading',
      )}
      text={t(
        gaveUp
          ? 'pages.onboarding.v1.obstaclesFeedback.gaveUp.description'
          : 'pages.onboarding.v1.obstaclesFeedback.general.description',
      )}
      onSubmit={handleSubmit}
    />
  )
}
